import { BURKHALTER_LOGIN } from "../constants";

const Redirect = () => {
  window.location.href = (BURKHALTER_LOGIN);
  return null;
}

export default Redirect;
